import React, { FC } from 'react';
import * as styles from './styles';

interface LoadingProps {
    fullScreen?: boolean;
}

const Loading: FC<LoadingProps> = (props) => {
    const { fullScreen } = props;

    return (
        <div css={[styles.wrapper, fullScreen ? styles.fixed : null]}>
            <div css={styles.loading}>
                <div css={styles.spinner}>
                    <div css={styles.inside} />
                    <div css={styles.inside} />
                </div>
            </div>
        </div>
    );
};

export default Loading;
